module.exports = __webpack_public_path__ + "img/screen-share.ec4553bf.svg";